module.exports = __webpack_public_path__ + "static/media/oeko-tex.3d06575a.png";